import styled from 'styled-components'
import { Row } from 'antd'

export const StyledRow = styled(Row)`
  margin-bottom: 0px;
`
